import type { MessageHandlerDeps } from '../../message-handler-deps.js';

type SessionGitReply = (payload: Record<string, unknown>, encryptedFields?: readonly string[]) => void;

export async function handleSessionGitPushAction(
  deps: MessageHandlerDeps,
  sessionId: string,
  reply: SessionGitReply,
): Promise<void> {
  const pushRes = await deps.sessionWorktreeManager.pushSessionUpstream(sessionId);
  if (!pushRes.ok) {
    reply({ ok: false, error: pushRes.error ?? 'Push failed' });
    return;
  }
  const st = await deps.sessionWorktreeManager.getSessionWorkingTreeStatus(sessionId);
  reply({
    ok: true,
    hasUncommittedChanges: st.hasUncommittedChanges,
    hasUnpushedCommits: st.hasUnpushedCommits,
    uncommittedFileCount: st.uncommittedFileCount,
  });
}
